<template>
  <div class="product-block loading flex-column">
    <a class="desktop-image" href="#">
      <div class="empty"></div>
    </a>
    <div class="meta-row flex-row">
      <a href="#" @click.prevent class="name flex-stretch">
        {{ product.name }}
      </a>
    </div>
    <div class="add-row flex-row flex-align-center">
      <Button disabled>▒▒▒ ▒▒ ▒▒▒</Button>
      <span class="flex-stretch" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from "@/stores/defs/shop_defs";
import Button from "primevue/button";

// █▓▒░

const product: Product = {
  id: 0,
  slug: "----",
  name: "▒▒▒▒▒▒▒▒ ▒▒▒▒ ▒▒▒▒▒▒▒▒",
  description: "▒▒▒▒ ▒▒▒▒ ▒▒▒▒▒▒▒▒ ▒▒▒▒ ▒▒▒▒▒▒▒▒ ▒▒▒▒",
  active: true,
  stock: 300,
  volume: "",
  remote_id: "",
  is_parent: false,
  images: [],
  videos: [],
  parent: 0,
  category: 0,
  categories: [],
  date_added: "",
  inventory_source: "",
  release_date: "",
  complete_look: [],
  cl_refs: [],
  prices: {
    null: 0,
  },
  deployed: new Date(),
};
</script>

<style scoped>
.product-block {
  max-width: 384px;
  min-width: 100px;
  background: white;
}
.product-block > a {
  display: grid;
}
.product-block .empty {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 8/10;
  margin: auto;
  grid-row: 1/1;
  grid-column: 1/1;
}
.product-block .name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-block .meta-row {
  margin: var(--2XS, 8px) 0;
}
.product-block .meta-row,
.product-block .add-row {
  gap: var(--2XS, 8px);
}

.mobile-image {
  display: none;
}
</style>
